<template>
  <PopupPane class="MultichoiceStartPane" v-bind="{ hidePopup }">
    <template v-slot:header>
      <h3 class="prompt">{{ content.prompt }}</h3>
      <p class="message">{{ content.message }}</p>
    </template>
    <template v-slot:default>
      <div class="options">
        <SmallCtaButton
          :text="localeStrings.leadFormOption"
          @click="selectOption('leadForm', localeStrings.leadFormOption)"
          class="--dark-blue"
        />
        <!-- <SmallCtaButton v-if="content.gatedContent"
          :text="content.gatedContent.buttonText"
          @click="selectOption('gatedContent', content.gatedContent.buttonText)"
          class="--dark-blue"
        /> -->
        <SmallCtaButton v-if="content.caseStudies && content.caseStudies.length > 0"
          :text="localeStrings.caseStudiesOption"
          @click="selectOption('caseStudies', localeStrings.caseStudiesOption)"
          class="--dark-blue"
        />
        <SmallCtaButton v-if="content.genericCta && content.genericCta.text"
          v-bind="content.genericCta"
          class="--dark-blue"
        />
      </div>
    </template>
  </PopupPane>
</template>

<!--
18 Feb 2025: As we don't have Marketo any more we can't currently deliver gated
content, but will be able to again once Hubspot is set up. See also the
GatedContentDownloadModule.
-->

<script>
import strings from './strings.json'

import PopupPane from './PopupPane.vue'

export default {
  components: {
    PopupPane,
  },
  inject: ['locale'],
  props: {
    content: Object,
    hidePopup: Function,
    selectOption: Function,
  },
  computed: {
    localeStrings() {
      return strings[this.locale]?.startPane
    },
  },
}
</script>

<style scoped>

.prompt {
  font-weight: 600;
  font-size: var(--font-size-4);
  color: var(--text-color-white);
}

.message {
  max-width: 21rem;
  font-weight: 500;
  font-size: var(--font-size-3);
  color: var(--text-color-white);
}

.prompt, .message {
  margin-top: var(--spacing-4);
}

.options {
  display: flex;
  flex-direction: column;
  row-gap: var(--spacing-5);
}
</style>
